import Vue from 'vue';

const success = (context, response) => {
  toastr.success(response.msg);
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, schedulePayment) => {
  return Vue.$http.post('schedule-payments/change-status', {schedulePayment})
    .then(response => {
      if (response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch(error => {
        failed(context, error);
    });
}



// WEBPACK FOOTER //
// ./src/app/services/schedule-payment/changeStatus.js